import React from 'react';
import { Box, Typography } from '@mui/material';
import { LABEL_GAP } from './inputStyles';
import User from 'lucide-react/dist/esm/icons/user';
import Target from 'lucide-react/dist/esm/icons/target';
import Heart from 'lucide-react/dist/esm/icons/heart';
import Brain from 'lucide-react/dist/esm/icons/brain';
import Compass from 'lucide-react/dist/esm/icons/compass';
import MessageSquare from 'lucide-react/dist/esm/icons/message-square';
import Globe from 'lucide-react/dist/esm/icons/globe';
import Calendar from 'lucide-react/dist/esm/icons/calendar';
import FileText from 'lucide-react/dist/esm/icons/file-text';
import Smile from 'lucide-react/dist/esm/icons/smile';
import Sparkles from 'lucide-react/dist/esm/icons/sparkles';
import Laugh from 'lucide-react/dist/esm/icons/laugh';
import Milestone from 'lucide-react/dist/esm/icons/milestone';
import Sprout from 'lucide-react/dist/esm/icons/sprout';
import Layers from 'lucide-react/dist/esm/icons/layers';
import TrendingUp from 'lucide-react/dist/esm/icons/trending-up';
import HelpCircle from 'lucide-react/dist/esm/icons/help-circle';

const icons = {
  User,
  Target,
  Heart,
  Brain,
  Compass,
  MessageSquare,
  Globe,
  Calendar,
  FileText,
  Smile,
  Sparkles,
  Laugh,
  Milestone,
  Sprout,
  Layers,
  TrendingUp
};

const colorMap = {
  blue: { main: '#3966f8', bg: 'rgba(57, 102, 248, 0.08)' },
  purple: { main: '#9c27b0', bg: 'rgba(156, 39, 176, 0.08)' },
  orange: { main: '#ff9800', bg: 'rgba(255, 152, 0, 0.08)' },
  green: { main: '#4caf50', bg: 'rgba(76, 175, 80, 0.08)' }
};

export const FormLabelWithIcon = ({ iconName, labelText, type = 'blue', required = false, style }) => {
  const IconComponent = icons[iconName] || HelpCircle;
  const colors = colorMap[type] || colorMap.blue;

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 0, marginBottom: LABEL_GAP, ...style }}>
      <Box
        style={{
          width: 24,
          height: 24,
          borderRadius: 6,
          backgroundColor: colors.bg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}
      >
        <IconComponent size={14} color={colors.main} strokeWidth={2.5} />
      </Box>
      <Typography style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
        {labelText}
        {required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
      </Typography>
    </Box>
  );
};

export default FormLabelWithIcon;
